import Vue            from 'vue';
import VuePageTitle   from 'vue-page-title';

import App            from './App.vue';
import router         from './router';
import store          from './store';

import axios          from "axios";
import VueAxios       from "vue-axios";
import Notifications  from 'vue-notification';
import VeeValidate    from 'vee-validate';
//import VueAnalytics   from 'vue-analytics'
 
import moment         from "vue-moment";
import VueTimeago     from "vue-timeago";
import VueClipboard   from "vue-clipboard2";
import VueMq          from 'vue-mq';
import vueInsomnia    from "vue-insomnia";

Vue.use(VueAxios, axios);
Vue.use(Notifications);
Vue.use(VeeValidate);
Vue.use(VuePageTitle, {
	// prefix: 'FiledSafely',
	// suffix: '- My App '
});

Vue.use(moment);
Vue.use(VueTimeago, {
    name:   'Timeago',
    locale: 'en',       // Default locale
});

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard);

Vue.use(VueMq, {
    breakpoints: {
        mobile: 801,
        tablet: 901,
        //laptop: 1250,
        desktop: Infinity,
    }
});

//Vue.use(VueAnalytics, {
//    id: 'UA-174587337-1',
//    checkDuplicatedScript: true,
//    router
//})

Vue.use(vueInsomnia);



if (process.env.VUE_APP_ENV == 'production') {
	axios.defaults.baseURL = 'https://api.filedsafely.com/';
}
else if (process.env.VUE_APP_ENV == 'staging') {
	axios.defaults.baseURL = 'http://staging-api.filedsafely.com/';
}
else {
	axios.defaults.baseURL = 'http://api.filedsafely.local/';
}


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
